import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 35,
  medium: 26,
  small: 18,
  xSmall: 15
};
const Rewind10SecondsIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M3.85199 9.92659C6.20573 4.98163 11.6976 2.1959 17.1785 3.3609C23.6611 4.73882 27.7992 11.111 26.4213 17.5936C25.2975 22.8807 20.7978 26.7156 15.5027 27.0739L15.2022 27.0905L15.2447 28.0896C21.1224 27.8397 26.159 23.6373 27.3995 17.8015C28.8922 10.7787 24.4092 3.87549 17.3864 2.38275C11.4793 1.12715 5.56098 4.10719 2.98894 9.41373L2.98926 4.69824L1.98926 4.69824V10.9267H8.21773L8.21773 9.92672L3.85199 9.92659Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0925 20.14C17.5925 20.14 18.0009 20.025 18.3175 19.795C18.6342 19.565 18.8809 19.2717 19.0575 18.915C19.2342 18.5584 19.3542 18.1667 19.4175 17.74C19.4809 17.3134 19.5125 16.9 19.5125 16.5C19.5125 16.1 19.4809 15.6867 19.4175 15.26C19.3542 14.8334 19.2342 14.4417 19.0575 14.085C18.8809 13.7284 18.6342 13.435 18.3175 13.205C18.0009 12.975 17.5925 12.86 17.0925 12.86C16.5925 12.86 16.1842 12.975 15.8675 13.205C15.5509 13.435 15.3042 13.7284 15.1275 14.085C14.9509 14.4417 14.8309 14.8334 14.7675 15.26C14.7042 15.6867 14.6725 16.1 14.6725 16.5C14.6725 16.9 14.7042 17.3134 14.7675 17.74C14.8309 18.1667 14.9509 18.5584 15.1275 18.915C15.3042 19.2717 15.5509 19.565 15.8675 19.795C16.1842 20.025 16.5925 20.14 17.0925 20.14ZM16.4675 18.975C16.6309 19.1184 16.8392 19.19 17.0925 19.19C17.3392 19.19 17.5459 19.1184 17.7125 18.975C17.8792 18.8317 18.0109 18.6384 18.1075 18.395C18.2042 18.1517 18.2725 17.8667 18.3125 17.54C18.3525 17.2134 18.3725 16.8667 18.3725 16.5C18.3725 16.1334 18.3525 15.7884 18.3125 15.465C18.2725 15.1417 18.2042 14.8567 18.1075 14.61C18.0109 14.3634 17.8792 14.1684 17.7125 14.025C17.5459 13.8817 17.3392 13.81 17.0925 13.81C16.8392 13.81 16.6309 13.8817 16.4675 14.025C16.3042 14.1684 16.1742 14.3634 16.0775 14.61C15.9809 14.8567 15.9125 15.1417 15.8725 15.465C15.8325 15.7884 15.8125 16.1334 15.8125 16.5C15.8125 16.8667 15.8325 17.2134 15.8725 17.54C15.9125 17.8667 15.9809 18.1517 16.0775 18.395C16.1742 18.6384 16.3042 18.8317 16.4675 18.975Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M12.2525 20V13H11.3225C11.2825 13.2134 11.1975 13.3934 11.0675 13.54C10.9375 13.6867 10.7809 13.8067 10.5975 13.9C10.4142 13.9934 10.2092 14.06 9.98252 14.1C9.75586 14.14 9.52252 14.16 9.28252 14.16V15.06H11.0025V20H12.2525Z",
        fill: "currentColor"
      }
    )
  );
};
Rewind10SecondsIcon.iconName = "Rewind10SecondsIcon";

export { Rewind10SecondsIcon };
